/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
export const SERVER_DATA = {
  local: "http://localhost:3000",
  qa: "https://staging1.nvipani.com",
  staging: "https://qa.nvipani.com",
  production: "https://valuchain.nvipani.com",
};

export const MS_BACKEND_DATA = {
  local: "https://qa-new.shopconnect.co.in",
  qa: "https://qa-new.shopconnect.co.in",
  staging: "https://staging-new.shopconnect.co.in",
  production: "https://shopconnect.co.in",
};
